import { useTranslation } from '@thoughtspot/i18n';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { TranslationsKeys } from './util';
export const useDataHooks = (useGetRolesQuery, roleListInput, isRefreshed, setIsLoading, setIsRefresh, hideErrorBanner) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { data: rolesList, error: rolesListError, loading: rolesListLoading, refetch: refreshRolesList, } = useGetRolesQuery(roleListInput);
    useEffect(() => {
        if (isRefreshed) {
            refreshRolesList({ data: roleListInput })
                .catch(() => {
            })
                .finally(() => {
                setIsLoading(false);
            });
            setIsRefresh(false);
        }
    }, [isRefreshed]);
    useEffect(() => {
        try {
            if (!_.isEmpty(rolesList) && !rolesListLoading) {
                const roleData = _.cloneDeep(rolesList?.Data.roles || []);
                const parseData = roleData.map((role) => {
                    const { id, name, description, privileges = [], author, created, modified, isDeleted, readOnly, numberOfGroupsAssigned, groups = [], } = role;
                    return {
                        id,
                        roleName: {
                            text: name || '',
                        },
                        roleDesc: {
                            text: description || t(TranslationsKeys.None),
                        },
                        numberOfPermission: {
                            text: privileges.length || 0,
                        },
                        numberOfGroupsAssigned: {
                            text: numberOfGroupsAssigned || 0,
                        },
                        groups,
                        privileges,
                        created,
                        readOnly,
                        isChecked: false,
                    };
                });
                setData(parseData);
                setLoading(false);
                setIsLoading(false);
                setIsRefresh(false);
                hideErrorBanner();
            }
        }
        catch (err) {
            setError(true);
            setLoading(false);
            setIsLoading(false);
        }
    }, [rolesList, roleListInput, rolesListLoading]);
    return {
        data,
        loading,
        error,
        isLastBatch: rolesList?.Data?.isLastBatch || false,
    };
};
//# sourceMappingURL=useDataHook.js.map